webpackJsonp([5,14],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	module.exports = __webpack_require__(84);


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(14);
	
	__webpack_require__(15);

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	"use strict";
	
	console.log("%c", "padding:18px 80px;line-height:80px;background:url('http://www.sunlands.com/img/logo.png') 100% no-repeat;");
	console.log("%c", "padding:80px 190px;line-height:110px;background:url('http://www.sunlands.com/img/feTeam.png') left center  no-repeat;background-size:50%;");
	console.log("%c 招聘信息:", "color:#2c2c2c;" + "font-family: 'Microsoft Yahei';" + "line-height:30px;" + "font-size:22px");
	console.log("%c 566A5Y6G6K+35Y+R6YCB6IezOiB5YW55dUBzdW5sYW5kcy5jb20gIOmCruS7tuivt+azqOaYjiBmcm9tIGNvbnNvbGUg ", "color:#2c2c2c;" + "font-family: 'Microsoft Yahei';" + "line-height:20px;" + "font-size:16px");

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var sdHostName = 'www.sunlands.com';
	var sdHostNameR = "moc.sdnalnus.www";
	var sdHostNameBase = sdHostNameR.split("").reverse().join("");
	var locationHArr = ['f', 'e', 'r', 'h'];
	var locationH = locationHArr.reverse().join("");
	var htTxtArr = ['/', '/', ':', 'p', 't', 't', 'h'];
	var htTxt = htTxtArr.reverse().join("");
	if (("production") == 'production' && window.location.hostname.indexOf('172') < 0 && window.location.hostname.indexOf('192') < 0 && window.location.hostname.indexOf('abctest') < 0 && window.location.hostname.indexOf('chunwan.sunlands.com') < 0) {
	    if (window.location.hostname != sdHostNameBase) {
	        window.location[locationH] = htTxt + sdHostNameBase;
	    }
	    if (sdHostName != sdHostNameBase) {
	        window.location[locationH] = htTxt + sdHostNameBase;
	    }
	}

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	__webpack_require__(18);
	
	(function () {
	    // 设置active
	    $($('.about-us-tabs').find('span').removeClass('active')[1]).addClass('active');
	    // 根据url匹配iframe高度
	    var pathname = window.location.pathname;
	    var height = '';
	    switch (pathname) {
	        case '/investorroom':
	        case '/investorroom/corporate-profile':
	            // Sunlands InvestorRoom（即投资关系页面，显示corportate profile的链接内容）
	            height = '1000px';
	            break;
	        case '/investorroom/management':
	            // Management - Sunlands InvestorRoom
	            height = '1600px';
	            break;
	        case '/investorroom/board-of-directors':
	            // Board of Directors - Sunlands
	            height = '3000px';
	            break;
	        case '/investorroom/committee-composition':
	            // Committee Composition - Sunlands InvestorRoom
	            height = '800px';
	            break;
	        case '/investorroom/corporate-governance':
	            // Corporate Governance - Sunlands InvestorRoom
	            height = '1000px';
	            break;
	        case '/investorroom/sec-filings':
	            // SEC Filings - Sunlands InvestorRoom
	            height = '1000px';
	            break;
	        case '/investorroom/financial-reports':
	            // Financial Reports - Sunlands InvestorRoom
	            height = '600px';
	            break;
	        case '/investorroom/analyst-coverage':
	            // Analyst Coverage - Sunlands InvestorRoom
	            height = '600px';
	            break;
	        case '/investorroom/stock-quote-chart':
	            // Stock Quote & Chart - Sunlands InvestorRoom
	            height = '600px';
	            break;
	        case '/investorroom/press-releases':
	            // Press Releases - Sunlands InvestorRoom
	            height = '800px';
	            break;
	        case '/investorroom/event-calendar':
	            // Event Calendar - Sunlands InvestorRoom
	            height = '800px';
	            break;
	        case '/investorroom/webcasts-and-presentations':
	            // Webcasts and Presantations - Sunlands InvestorRoom
	            height = '1000px';
	            break;
	        case '/investorroom/ir-contacts':
	            // IR Contacts - Sunlands InvestorRoom
	            height = '600px';
	            break;
	        case '/investorroom/email-alerts':
	            // Email Alerts - Sunlands InvestorRoom
	            height = '600px';
	            break;
	        case '/investorroom/contact-information':
	            // FAQ - Sunlands InvestorRoom
	            height = '800px';
	            break;
	        default:
	            height = '1000px';
	            break;
	    }
	    $('#investor_frame').css('height', height);
	})();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ })

});


// WEBPACK FOOTER //
// investor.js